import React, { useEffect, useRef, useState } from "react";
import "./Conocenos.module.css";
import fruit from "../../../../Assets/img/logoVisnu.png";
import crop3 from "../../../../Assets/img/crop3.png";
import crop2 from "../../../../Assets/img/crop2.png";
import style from "./Conocenos.module.css";
import HorizontalScroll from "react-scroll-horizontal";
import { useMediaQuery } from "@material-ui/core";

export const Conocenos = () => {
  const mobile = useMediaQuery("(max-width:768px)");
  const horizontalScrollRef = useRef(null);
  const containerRef = useRef(null);
  const [showScrollHint, setShowScrollHint] = useState(true);

  useEffect(() => {
    if (!mobile && horizontalScrollRef.current) {
      const wrapper = horizontalScrollRef.current;
      
      // Ocultar el hint después de 5 segundos o cuando el usuario haga scroll
      const hideHintTimeout = setTimeout(() => {
        setShowScrollHint(false);
      }, 5000);

      // Buscar el contenedor de scroll una vez
      const findScrollContainer = () => {
        return wrapper.querySelector('div[style*="overflow"]') || 
               Array.from(wrapper.querySelectorAll('div')).find(el => {
                 const style = window.getComputedStyle(el);
                 return style.overflowX === 'auto' || style.overflowX === 'scroll';
               }) || wrapper;
      };

      const handleWheel = (e) => {
        // Solo procesar eventos que vengan del área del scroll horizontal
        const target = e.target;
        if (!wrapper.contains(target)) {
          return;
        }

        // Ocultar el hint cuando el usuario empiece a hacer scroll
        if (showScrollHint) {
          setShowScrollHint(false);
        }

        const scrollContainer = findScrollContainer();
        if (!scrollContainer) return;

        const scrollLeft = scrollContainer.scrollLeft || 0;
        const scrollWidth = scrollContainer.scrollWidth || 0;
        const clientWidth = scrollContainer.clientWidth || 0;
        const maxScroll = Math.max(0, scrollWidth - clientWidth);
        const isAtEnd = scrollLeft >= maxScroll - 50;
        const isAtStart = scrollLeft <= 50;

        // Detectar la intención del usuario: ¿scroll vertical o horizontal?
        const absDeltaY = Math.abs(e.deltaY);
        const absDeltaX = Math.abs(e.deltaX);
        
        // Si el scroll vertical es claramente mayor que el horizontal, es scroll vertical
        const isVerticalScroll = absDeltaY > absDeltaX * 1.5;

        // Si el usuario claramente quiere hacer scroll vertical, prevenir que react-scroll-horizontal lo intercepte
        if (isVerticalScroll) {
          // Prevenir que el evento llegue a react-scroll-horizontal
          e.stopPropagation();
          e.stopImmediatePropagation();
          // No prevenir el default para que el scroll vertical natural funcione
          return;
        }

        // Si está al final y el usuario quiere hacer scroll hacia abajo
        if (isAtEnd && e.deltaY > 0) {
          e.stopPropagation();
          e.stopImmediatePropagation();
          return;
        }

        // Si está al inicio y el usuario quiere hacer scroll hacia arriba
        if (isAtStart && e.deltaY < 0) {
          e.stopPropagation();
          e.stopImmediatePropagation();
          return;
        }

        // Si no es claramente scroll vertical y no está en los extremos, 
        // permitir que react-scroll-horizontal maneje el scroll horizontal
        // No prevenir el evento, dejar que se propague
      };

      // Interceptar en el wrapper y en el document con capture para interceptar ANTES de react-scroll-horizontal
      // Primero en el wrapper para capturar eventos dentro del área
      wrapper.addEventListener('wheel', handleWheel, { 
        passive: false,
        capture: true 
      });

      // También en el document para capturar todos los eventos que pasen por el área
      const documentHandler = (e) => {
        // Solo procesar si el evento viene del área del scroll horizontal
        if (wrapper.contains(e.target)) {
          handleWheel(e);
        }
      };

      document.addEventListener('wheel', documentHandler, { 
        passive: false,
        capture: true 
      });

      return () => {
        clearTimeout(hideHintTimeout);
        wrapper.removeEventListener('wheel', handleWheel, { capture: true });
        document.removeEventListener('wheel', documentHandler, { capture: true });
      };
    }
  }, [mobile, showScrollHint]);

  return (
    <div
      id="conocenos"
      ref={containerRef}
      className={!mobile ? style.container : style.containerMob}
    >
      {!mobile ? (
        <>
        <div ref={horizontalScrollRef} className={style.horizontalWrapper}>
          {showScrollHint && (
            <div className={style.scrollHint}>
              <span className={style.scrollHintText}>Desliza para ver más</span>
              <div className={style.scrollHintArrow}>
                <span>→</span>
                <span>→</span>
                <span>→</span>
              </div>
            </div>
          )}
          <HorizontalScroll reverseScroll={true}>
          <div className={style.item1}>
            <img src={fruit} alt="" className={style.imgLogo} />
            <div className={style.txtCont}>
              <h1 className={style.title}>Conócenos</h1>
              <p className={style.txt}>
                Comprometida con el cuidado y la conciencia de la salud mental y
                corporal a través de la naturaleza, y la calidad de sus
                servicios brindados por excelentes colaboradores emprendedores.
                Dando una conexión al consumidor de apoyo, oportunidad,
                formalidad, recreación, adaptabilidad, y sobre todo abarcando
                las necesidades que ellos requieren. Su objetivo no solo es
                transformar y adaptar sus servicios para las necesidades y el
                bienestar de sus clientes, al mismo tiempo se centra en
                transformar la vida de cada uno de ellos. Enfocada en forjar la
                cultura de cambio total y constante, reinventándose a diario,
                siendo una marca auténtica que siempre mantenga su esencia, pero
                su forma de adaptarse sea parte de su caminar.
              </p>
              <h4 className={style.title2}>Nuestros valores</h4>
              <p className={style.txt3}>
                <span className={style.dot1}>•</span> Responsabilidad social
                <span className={style.dot1}>•</span> Cuidado ambiental <br />
                <span className={style.dot1}>•</span> Ingredientes y materiales
                de calidad
                <span className={style.dot1}>•</span> Creación de oportunidades
                <span className={style.dot1}>•</span> Innovación constante
              </p>
            </div>
          </div>

          <div className={style.item2}>
            <div className={style.columnA}>
              <div className={style.txtCont2}>
                <div>
                  <img src={crop2} alt="" />
                </div>

                <h1 className={style.title}>Misión</h1>
                <p className={style.txt}>
                Distribuir productos y servicios de primera calidad de la mano de excelentes artesanos 
                y profesionales emprendedores, al mismo tiempo que expandimos nuestras fronteras adentrándonos
                 a varios giros de negocios siempre de la mano del equilibrio físico y mental.
                </p>
              </div>
            </div>

            <div className={style.columnB}>
              {" "}
              <div className={style.txtCont2}>
                <div>
                  {" "}
                  <img src={crop3} alt="" />
                </div>
                <h1 className={style.title}>Visión</h1>
                <p className={style.txt}>
                Posicionarnos en el mercado como una de las marcas más reconocidas por la 
                calidad y diversidad de nuestros productos y servicios. Así como también ser 
                apoyo, proveer y enseñar a cientos de guatemaltecos en búsqueda de superarse, 
                a utilizar recursos para generar ingresos por medio de empleos y capacitaciones 
                en nuestra sede.
                </p>
              </div>
            </div>
          </div>
        </HorizontalScroll>
        </div>
        {/* Espacio para permitir scroll vertical después del horizontal */}
        <div className={style.scrollSpacer}></div>
        </>
      ) : (
        <>
          <div className={style.item1Mob}>
            <div className={style.txtContMob}>
              <h1 className={style.titleMob}>Conócenos</h1>
              <p className={style.txtMob}>
                Comprometida con el cuidado y la conciencia de la salud mental y
                corporal a través de la naturaleza, y la calidad de sus
                servicios brindados por excelentes colaboradores emprendedores.
                Dando una conexión al consumidor de apoyo, oportunidad,
                formalidad, recreación, adaptabilidad, y sobre todo abarcando
                las necesidades que ellos requieren.
              </p>{" "}
              <img src={fruit} alt="" className={style.imgMob} />
              <p className={style.txtMobAlt}>
                Su objetivo no solo es transformar y adaptar sus servicios para
                las necesidades y el bienestar de sus clientes, al mismo tiempo
                se centra en transformar la vida de cada uno de ellos. Enfocada
                en forjar la cultura de cambio total y constante, reinventándose
                a diario, siendo una marca auténtica que siempre mantenga su
                esencia, pero su forma de adaptarse sea parte de su caminar."
              </p>
            </div>
          </div>

          <div className={style.item2Mob}>
            <div className={style.columnA}>
              <div className={style.txtCont2Mob}>
                <div>
                  <img src={crop2} alt="" className={style.imgMob} />
                </div>

                <h1 className={style.title}>Misión</h1>
                <p className={style.txtMob}>
                  Distribuimos productos fabricados con ingredientes naturales,
                  al mismo tiempo que expandimos nuestras fronteras
                  adentrándonos a varios giros de negocios siempre de la mano
                  del equilibrio físico y mental.
                </p>
              </div>
            </div>

            <div className={style.columnB}>
              {" "}
              <div className={style.txtCont3Mob}>
                <div>
                  {" "}
                  <img src={crop3} alt="" className={style.imgMob} />
                </div>
                <h1 className={style.title}>Visión</h1>
                <p className={style.txtMob}>
                  Posicionarnos en el mercado guatemalteco como una de las
                  marcas más reconocidas por la calidad y diversidad de nuestros
                  productos y servicios, así como también ser apoyo de cientos
                  de guatemaltecos en búsqueda de superarse a si mismos.
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

/*     <div className={style.container}>
      <HorizontalScroll>
        <div style={child}>
          <img src={fruit} alt="" />
          <div className={style.txtCont}>
            <h1 className={style.title}>Conócenos</h1>
            <p className={style.txt}>
              Nuestra pasión es la transformación para cubrir las necesidades de
              nuestros clientes y aliados, somos evolución siempre conservando
              nuestros valores y principios, pero moldeándonos a tus
              necesidades. Somos una marca matriz con diferentes giros de
              negocio, y queremos devolverles a nuestros clientes la confianza
              en las bondades de la naturaleza y la conciencia de la salud por
              medio del equilibrio mental y corporal a través de nuestras líneas
              de productos, fabricados por excelentes artesanos emprendedores.
            </p>
            <h4 className={style.title2}>Nuestros valores</h4>
            <p className={style.txt2}>
              <span className={style.dot1}>•</span> Responsabilidad social
              <span className={style.dot1}>•</span> Cuidar el medio ambiente
              <span className={style.dot1}>•</span> Calidad
              <span className={style.dot1}>•</span> Creación de oportunidades
              <span className={style.dot1}>•</span> Innovación constante
            </p>
          </div>
        </div>
        <div style={child}>
          <div className={style.item1}>
            {" "}
            <div className={style.txtCont2}>
              <img src={crop2} alt="" />
              <h1 className={style.title}>Misión</h1>
              <p className={style.txt}>
                Distribuimos productos fabricados con ingredientes naturales, al
                mismo tiempo que expandimos nuestras fronteras adentrándonos a
                varios giros de negocios siempre de la mano del equilibrio
                físico y mental.{" "}
              </p>
            </div>
          </div>

          <div className={style.item2}>
            {" "}
            <div className={style.txtCont2}>
              <img src={crop3} alt="" />
              <h1 className={style.title}>Visión</h1>
              <p className={style.txt}>
                Posicionarnos en el mercado guatemalteco como una de las marcas
                más reconocidas por la calidad y diversidad de nuestros
                productos y servicios, así como también ser apoyo de cientos de
                guatemaltecos en búsqueda de superarse a si mismos.{" "}
              </p>
            </div>
          </div>
        </div>
      </HorizontalScroll>
    </div>   */
